// Detects whether the scene has moved (any camera or object) since a given
// point in time — the basis for AiRenderOverlay's "Create Projection" gate
// (see Scene3DEditor.jsx's canCreateProjectionFor). Only the fields that
// actually affect where geometry ends up on screen are hashed; cosmetic
// fields (name, description, color, texture, light intensity, aiDescription,
// ...) are deliberately left out so tweaking them never blocks a projection
// that's otherwise still perfectly aligned.
const STRUCTURAL_FIELDS = [
  "_id",
  "type",
  "parent",
  "order",
  "visible",
  "transform",
  "geometry",
  "modelUrl",
  "modelKey",
  "modelNodePath",
  // camera-only, but harmless to include for every node type — affects the
  // frustum a piloted camera actually captures.
  "fov",
  "aspect",
];

// Sorted by `_id` rather than left in array order — a node's position within
// the `nodes` array itself isn't meaningful (only `order`+`parent`, already
// included above, encode where it sits in the tree), so e.g. pasting a new
// node at the end of the array shouldn't perturb every other node's hash
// input ordering.
function structuralNodeSnapshot(nodes) {
  return [...nodes]
    .sort((a, b) => (a._id < b._id ? -1 : a._id > b._id ? 1 : 0))
    .map((node) =>
      STRUCTURAL_FIELDS.reduce((acc, field) => {
        acc[field] = node[field] ?? null;
        return acc;
      }, {}),
    );
}

// FNV-1a, 32-bit — not cryptographic, just fast and stable across the same
// input string, which is all a "did anything structural change" check needs.
function fnv1a(str) {
  let hash = 0x811c9dc5;
  for (let i = 0; i < str.length; i++) {
    hash ^= str.charCodeAt(i);
    hash = Math.imul(hash, 0x01000193);
  }
  return (hash >>> 0).toString(16).padStart(8, "0");
}

export function hashNodes(nodes) {
  return fnv1a(JSON.stringify(structuralNodeSnapshot(nodes)));
}
